import React from "react";

const HistoryItemsPCWrapper = (props) => {

  return (
    <div className="col-1">
      <div className="vehicle-fix-haeder ">
        <div className="history-container">
          <div className="align-items-center justify-content-center vehicle-fix-haeder ">
            <div className="row no-gutters">
              <div className="col-1"  >
                <div >
                  {props.showButton}
                </div>
              </div>
              <div className="col-4" >
                <div className=" vh-plate" style={{ leftPadding: "25px" }} >
                  {props.infoStr}
                </div>
              </div>

              <div className="col"  >
                {props.historyDate}
              </div>
              <div className="col-1" style={{ textAlign: 'right' }}>
                {props.close}
              </div>
            </div>
          </div>
          <div id="collapseExample" className="show wrap">
            <div className="row no-gutters grid-title">
              <div className="col-4">
                Timestamp

              </div>
              <div className="col">
                Odometer
              </div>
              <div className="col">
                Location
              </div>

            </div>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryItemsPCWrapper;